export default class SlideMenu {
    constructor() {
        this.events = this.events.bind(this);
        this.dropdown = this.dropdown.bind(this);
        this.events();
    }

    // Set up the events to control the opening
    // and closing of the menu
    events() {
        // When the hamburger is clicked
        $(document).on('tap click', '.menu-toggle', e => {
            // Stop the page from scrolling
            e.preventDefault();
            // Toggle the menu state
            return this.toggleMenu();
        });

         // When the hamburger is clicked
        $(document).on('tap click', '[data-dropdown]', function(e) {
            // Stop the page from scrolling
            e.preventDefault();
            // Toggle the menu state
            if ($(this).is('i')) {
                $(this).toggleClass('open');
                return $(this).next('ul').slideToggle();
            } else {
                $(this).next('i').toggleClass('open');
                return $(this).siblings('ul').slideToggle();
            }
        });

        $(document).on('tap click', '.sub-toggle', e => {
            e.preventDefault();
            return this.toggleNav();
        });


        // When the dark overlay is clicked
        // while the menu is open
        $(document).on('click', 'body.nav-open #content-overlay', () => {
            // Close the menu
            return this.closeMenu();
        });

        $(document).on('click', 'body.account-nav-open #content-overlay', () => {
            $('.sub-nav').removeClass('open');
            return $('body').removeClass('account-nav-open');
        });

        let width = $(window).width();

        // When the window resizes
        $(window).resize(() => {
            // Check if the menu is open
            if ($('body.nav-open').length) {
                // Close the menu
                if ($(window).width() !== width) {
                    return this.closeMenu();
                }
            }
        });

        return $(window).scroll(() => {
            if ($('header').hasClass('translate3d-fix')) {
                return $('header').css({
                    top: $(window).scrollTop()
                });
            }
        });
    }
    // Method to toggle the menu state
    toggleMenu() {
        // Check if the nav is open
        if ($('body.nav-open').length) {
            // Close the menu
            return this.closeMenu();
        } else {
            // Open the menu
            return this.openMenu();
        }
    }

    toggleNav() {
        $('.sub-toggle').toggleClass('active');
        $('.sub-nav').toggleClass('open');
        return $('body').toggleClass('account-nav-open');
    }

    openMenu() {
        // Fix header positioning
        this.positionHeader();
        // Toggle the class that is used to open the navigation
        return $('body').addClass('nav-open');
    }

    closeMenu() {
        $('body').removeClass('nav-open');
        // Set delay to ensure the position resets
        // once the transitions have completed
        return setTimeout(() => {
            // Reset header positioning
            return this.resetHeader();
        }
        , 450);
    }

    // Chrome has a bug where translate resets
    // positioning for fixed elements, so we have
    // to manually enable the transform and position
    // the header
    positionHeader() {
        // Set the absolutely positioned headers offset from
        // the top based on scroll position
        return $('header').css({
            top: $(window).scrollTop()});
    }

    // Do the inverse
    resetHeader() {
        return $('header').attr({
            'style' : ''});
    }

    dropdown() {
        // toggles child pages
        return $(this).next('ul').slideToggle();
    }
};
